import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import type { RequestContext } from "../commissionEditQueue.types";
import { createCommissionEditQueueColumns } from "../commissionEditQueueColumns";

interface CommissionEditQueueTableProps {
  requests: RequestContext[];
  onSelect: (context: RequestContext) => void;
}

export function CommissionEditQueueTable({
  requests,
  onSelect,
}: CommissionEditQueueTableProps) {
  const columns = useMemo(() => createCommissionEditQueueColumns(onSelect), [onSelect]);

  return (
    <DataTable
      columns={columns}
      data={requests}
      emptyMessage="Aucune demande ne correspond aux filtres."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
